import { Badge } from "../../primitives/badge";
import { cn } from "../../primitives/utils";

interface SegmentBadgeProps {
  segment: string;
  className?: string;
}

const segmentConfig: Record<
  string,
  { className: string; style: React.CSSProperties }
> = {
  strategic: {
    className: "border-transparent",
    style: {
      backgroundColor: "var(--segment-strategic)",
      color: "#ffffff",
    },
  },
  key: {
    className: "border-transparent",
    style: {
      backgroundColor: "var(--segment-key)",
      color: "#ffffff",
    },
  },
  client: {
    className: "border-transparent",
    style: {
      backgroundColor: "var(--segment-client)",
      color: "#ffffff",
    },
  },
  prospect: {
    className: "border-transparent",
    style: {
      backgroundColor: "var(--segment-prospect)",
      color: "#ffffff",
    },
  },
};

export function SegmentBadge({ segment, className }: SegmentBadgeProps) {
  // Handle undefined/null segments gracefully
  const safeSegment = segment || "client";
  const config = segmentConfig[safeSegment] || segmentConfig.client;
  const label = safeSegment.charAt(0).toUpperCase() + safeSegment.slice(1);

  return (
    <Badge className={cn(config.className, className)} style={config.style}>
      {label}
    </Badge>
  );
}
